// ── 정산지급 내역 모달 (모바일 하단 시트) ─────────────────────────────────────
// MobileView에서 분리된 모달 컴포넌트

import React from 'react';
import { useBodyScrollLock } from '../../../hooks/useBodyScrollLock';
import { useOverlayClickClose } from '../../../hooks/useOverlayClickClose';
import { fmt } from './utils';
import { TimelineItem } from './PayComponents';
import {
  stdModalHeaderBar, stdModalHeaderIconBox, stdModalHeaderTitle, stdModalHeaderSub, stdModalCloseBtn,
} from '../../admin/adminlayout/designStandard';

export function SettlementRecordsModal({ records, recTotal, settlementItems, onClose }) {
  useBodyScrollLock(true);
  const overlayCloseProps = useOverlayClickClose(onClose);
  return (
    <div
      {...overlayCloseProps}
      style={{
        position: 'fixed', inset: 0, zIndex: 2000,
        background: 'rgba(0,0,0,0.55)',
        display: 'flex', alignItems: 'flex-end',
      }}
    >
      {/* 시트 본문 — 클릭 이벤트 버블링 차단 */}
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%', maxHeight: 'min(72vh, calc(100dvh - 24px))',
          background: 'var(--bg-card)',
          borderRadius: '20px 20px 0 0',
          display: 'flex', flexDirection: 'column',
          boxShadow: '0 -4px 24px rgba(0,0,0,0.18)',
        }}
      >
        {/* 모달 헤더 — 검정 표준 밴드 (2026-08-31 모달 통일) */}
        <div style={stdModalHeaderBar(20)}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
            <div style={stdModalHeaderIconBox} aria-hidden="true">💰</div>
            <div style={{ minWidth: 0 }}>
              <div style={stdModalHeaderTitle}>지금까지 정산받은 금액</div>
              <div style={stdModalHeaderSub}>
                총 {records.length}건 · {fmt(recTotal)}원
              </div>
            </div>
          </div>
          <button
            onClick={onClose}
            aria-label="닫기"
            style={stdModalCloseBtn}
          >✕</button>
        </div>

        {/* 정산지급 목록 — TimelineItem 재사용 */}
        <div style={{ overflowY: 'auto', padding: '8px 4px 24px', flex: 1 }}>
          {settlementItems.length === 0 ? (
            <div style={{ padding: '40px 24px', textAlign: 'center', color: 'var(--text-muted)', fontSize: 13 }}>
              정산지급 내역이 없습니다
            </div>
          ) : (
            settlementItems.map((item) => <TimelineItem key={item.key} item={item} />)
          )}
        </div>
      </div>
    </div>
  );
}
